<template>
  <div>

    <!-- app -->
    <v-app-bar
      flat
      dark
      color="cardIsland"
      height="60px"
    >
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer
      app
      dark
      v-model="drawer"
      color="cardIsland"
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <a @click="$router.push('/dashboard')">
                <v-img
                  src="../assets/logo-smaller.svg"
                  width="150px"
                />
            </a>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list
        dense
        nav
      >
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          @click="$router.push(`${item.path}`)"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="text-subtitle-1">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <div class="pa-2">
        <v-btn
          block
          color="primary"
          @click="logOut"
        >
          Logout
        </v-btn>
      </div>
    </v-navigation-drawer>
    <div>
      <router-view />
    </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify'

export default {
  data() {
    return {
      items: [
        { title: 'Buy', icon: 'mdi-arrow-down-bold-box', path: '/order/buy' },
        { title: 'Sell', icon: 'mdi-arrow-up-bold-box', path: '/order/sell' },
        { title: 'Address Book', icon: 'mdi-text-box', path: '/address-book' },
        { title: 'Account', icon: 'mdi-account-box', path: '/account' },
      ],
      right: null,
      drawer: null,
    }
  },
  methods: {
    async logOut() {
      try {
        await Auth.signOut()
        this.$store.commit('auth/setUser', null)
        this.$router.push('/login')
      } catch (err) {
        console.log('error signing out', err)
      }

    }
  }
};
</script>
